import {default as React, useState} from 'react';
import {Button, Form, FormSelect, Modal} from 'semantic-ui-react';
import {ColumnDefinition} from './common';
import i18n from '../../../../locale/i18n';
import {WithNamespaces, withNamespaces} from "react-i18next";

const t = i18n.t.bind(i18n);

interface SortSelectionProps {
  availableColumns: ColumnDefinition[];
  currentSortColumn: string;
  currentDirection: 'ASC' | 'DESC';

  onSave(column: string, direction: 'ASC' | 'DESC'): void;
  onCancel?(): void;
}

export interface SortSelectionButtonProps extends SortSelectionProps {
  fluid?:boolean;
}

export const SortSelectionButton = (props: SortSelectionButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (<>
    <Button icon="sort amount down"
            onClick={() => setIsVisible(true)}
            content={t("Common.SelectSort")}
            fluid={props.fluid}
    />
    <SortSelectionModal
      visible={isVisible}
      availableColumns={props.availableColumns}
      currentDirection={props.currentDirection}
      currentSortColumn={props.currentSortColumn}
      onSave={(column, direction) => {
        setIsVisible(false);
        props.onSave(column, direction);
      }}
      onCancel={() => {
        setIsVisible(false);
        if(props.onCancel) {
          props.onCancel();
        }
      }} />
  </>);
};

export interface SortSelectionModalProps extends SortSelectionProps {
  visible?: boolean;
}

export const SortSelectionModal = withNamespaces()((props: SortSelectionModalProps & WithNamespaces) => {
  const [selectedColumn, updateSelectedColumn] = useState(props.currentSortColumn);
  const [selectedDirection, updateSelectedDirection] = useState(props.currentDirection);

  return (
    <Modal open={props.visible}>
      <Modal.Header>{t("Common.SelectSort")}</Modal.Header>
      <Modal.Content>
        <Form>
            <FormSelect fluid
                        options={props.availableColumns.filter(c => !c.noSort).map(c => ({
                          value: c.fieldName,
                          text: c.labelTranslationKey? props.t(c.labelTranslationKey) : c.label
                        }))}
                        value={selectedColumn}
                        onChange={(ev, data) => updateSelectedColumn(data.value + '')}
            />
            <FormSelect fluid options={[
              {value: 'ASC', text: props.t('Common.Sort_Ascending')},
              {value: 'DESC', text: props.t('Common.Sort_Descending')}
            ]} value={selectedDirection}
               onChange={(ev, data) => updateSelectedDirection(data.value as 'ASC'|'DESC')}/>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={props.onCancel}>{t("Common.Cancel")}</Button>
        <Button onClick={() => props.onSave(selectedColumn, selectedDirection)} primary>{t("Common.Apply")}</Button>
      </Modal.Actions>
    </Modal>
  );
});